exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@font-face{font-family:Roboto;font-style:normal;font-weight:300;src:local(\"Roboto Light\"),local(\"Roboto-Light\"),url(" + require("./fonts/roboto-v15-latin-300.woff2") + ") format(\"woff2\"),url(" + require("./fonts/roboto-v15-latin-300.woff") + ") format(\"woff\")}@font-face{font-family:Roboto;font-style:normal;font-weight:400;src:local(\"Roboto\"),local(\"Roboto-Regular\"),url(" + require("./fonts/roboto-v15-latin-regular.woff2") + ") format(\"woff2\"),url(" + require("./fonts/roboto-v15-latin-regular.woff") + ") format(\"woff\")}@font-face{font-family:Roboto;font-style:normal;font-weight:500;src:local(\"Roboto Medium\"),local(\"Roboto-Medium\"),url(" + require("./fonts/roboto-v15-latin-500.woff2") + ") format(\"woff2\"),url(" + require("./fonts/roboto-v15-latin-500.woff") + ") format(\"woff\")}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/autoprefixer-loader!./assets/fonts.css
// module id = 747
// module chunks = 0